import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ProductSelectionService } from "../../services/product-selection.service";
import { ProductDataService } from "../../services/product-data.service";

@Component({
    selector: "app-barcode-product-search",
    templateUrl: "./barcode-product-search.component.html",
    styleUrls: ["./barcode-product-search.component.scss"],
})
export class BarcodeProductSearchComponent implements OnInit {
    @Input() locationId;
    @Input() fromInventoryModule: boolean = false;
    @Input() accountId;
    @Output() onProductSelect = new EventEmitter();

    products = [];
    pageNumber = 1;
    pageSize = 15;
    searchText = "";

    constructor(
        private service: ProductSelectionService,
        private productDataService: ProductDataService,
    ) {}

    ngOnInit(): void {}

    onCompleteSearchProduct(e) {
        if (e?.target?.value && e.target.value.length > 0) {
            const data = {
                locationId: this.locationId,
                accountId: this.accountId,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                searchValue: e.target.value,
                typeId: 1,
            };
            this.service
                .getWarehouseWiseProductBarcode(data)
                .then((products) => {
                    let { inventory, headers } = products;
                    inventory = inventory == null ? [] : inventory;
                    headers = headers == null ? [] : headers;
                    this.products = this.productDataService.prepareProductsList(inventory);
                    this.onProductSelect.emit(this.products);
                    this.searchText = "";
                })
                .finally(() => {
                    // this.noProductFoundOrLoadingText = "No Products found.";
                });
        }
    }
}
